import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import { AlyceTheme, SanitizedHTML } from '@alycecom/ui';

import alyceGiftLogo from '../../assets/images/alyce-gift-logo.svg';
import { TFullSender } from '../../store/users/users.types';
import { getBranding } from '../../store/branding/branding.selectors';
import SenderInfo from '../SenderInfo';
import { IMessage } from '../../store/types/Message.types';

const useStyles = makeStyles<AlyceTheme, { logo: string }>(() => ({
  logo: {
    backgroundSize: 'contain',
    display: 'block',
    height: 40,
    width: '100%',
    backgroundImage: props => `url(${props.logo})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
  message: {
    wordBreak: 'break-word',
  },
}));

export interface IGiftTextMessageProps {
  message: IMessage;
  sender: TFullSender | null;
}

const GiftTextMessage = ({ message, sender }: IGiftTextMessageProps): JSX.Element => {
  const customStyling = useSelector(getBranding);
  const logo = customStyling.logoUrl || alyceGiftLogo;
  const classes = useStyles({ logo });
  const messageText = useMemo(
    () =>
      message.content &&
      message.content
        .replace(/(?:\r>|\r|>)/g, '&gt;')
        .replace(/(?:\r<|\r|<)/g, '&lt;')
        .replace(/(?:\r\n|\r|\n)/g, '<br />'),
    [message],
  );

  return (
    <>
      <Box mb={2}>
        <Box className={classes.logo} />
      </Box>
      <Box
        data-testid="giftMessageText"
        color="text.primary"
        fontSize={18}
        fontWeight={400}
        lineHeight={1.6}
        textAlign="left"
        mb={2}
        fontFamily="Lato"
      >
        <SanitizedHTML className={classes.message} html={messageText} />
      </Box>
      <SenderInfo sender={sender} />
    </>
  );
};

export default GiftTextMessage;
